<template>
  <aside class="cart-resume-container">
    <div class="wrapper">
      <h2>Total panier</h2>
      <table class="main-cart">
        <tbody class="main-cart__body">
        <tr class="details">
          <td>Sous-total (TVA incluse)</td>
          <td>{{ getTotalPrice }}€</td>
        </tr>

        <tr class="details">
          <td v-if="~~step === 1">Frais de transport(estimés)</td>
          <td v-else>Frais de transport</td>
          <td>{{ getShippingCost }}€</td>
        </tr>

        <!--				&lt;!&ndash;TODO v-if promo&ndash;&gt;-->
        <!--				<tr class="details promotion">-->
        <!--					<td>Réduction sur votre prochaine commande</td>-->
        <!--					<td>2.50€</td>-->
        <!--				</tr>-->
        </tbody>

        <!--TODO code promo, total final ...-->
        <tbody class="main-cart__body total-price">
        <tr class="details">
          <td>Réduction</td>
          <td>{{ getAmountDiscount }}€</td>
        </tr>
        <tr v-if="display">
          <td colspan="2">
            <div class="error" id="error-login" >
              <p>{{ getErrorMessage }}</p>
            </div>
          </td>
        </tr>
        <tr class="promo-code" v-if="isAuthenticated">
          <td colspan="2">
            <form @submit.prevent="getDiscount">
              <div class="form__row">
                <input type="text" placeholder="Mon code promo" v-model="form.discount" class="input"
                       style="width: auto">
                <button class="button" aria-label="send-form" type="submit">
                  <svg width="52" height="82" viewBox="0 0 52 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.84137 75.4239C11.4161 63.4726 24.1693 53.9096 34.931 42.8418C35.9512 41.7933 36.9617 40.7447 37.9427 39.6574C39.424 38.0166 40.8269 36.3467 42.1807 34.6283C43.2402 35.638 44.2997 36.5992 45.3592 37.5603C47.1839 39.1914 49.087 40.7059 50.9902 42.1719C50.1858 43.0068 49.3813 43.8515 48.5769 44.6476C46.713 46.5311 44.7607 48.5019 42.8183 50.4339C31.8898 61.4629 19.892 72.9093 6.75625 80.4626C3.41099 82.3946 -0.826992 78.7442 1.84137 75.4336V75.4239Z"
                        fill="white"/>
                    <path
                        d="M9.17935 1.83266C21.2949 11.3083 30.9186 23.978 42.1905 34.6283C43.25 35.638 44.3095 36.5992 45.369 37.5603C47.1937 39.1914 49.0968 40.7059 51 42.1719C50.1956 43.0068 49.3911 43.8515 48.5867 44.6476C46.7228 46.5311 44.7706 48.5019 42.8281 50.4339C41.9845 49.6378 41.131 48.8417 40.3266 48.0456C38.5509 46.3272 36.7655 44.6088 34.9408 42.8418C23.6297 31.939 11.8477 19.8615 4.0977 6.69667C2.14548 3.38604 5.83409 -0.808081 9.17935 1.83266Z"
                        fill="white"/>
                    <path
                        d="M1.84137 75.4239C11.4161 63.4726 24.1693 53.9096 34.931 42.8418C35.9512 41.7933 36.9617 40.7447 37.9427 39.6574C39.424 38.0166 40.8269 36.3467 42.1807 34.6283C43.2402 35.638 44.2997 36.5992 45.3592 37.5603C47.1839 39.1914 49.087 40.7059 50.9902 42.1719C50.1858 43.0068 49.3813 43.8515 48.5769 44.6476C46.713 46.5311 44.7607 48.5019 42.8183 50.4339C31.8898 61.4629 19.892 72.9093 6.75625 80.4626C3.41099 82.3946 -0.826992 78.7442 1.84137 75.4336V75.4239Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path
                        d="M9.17935 1.83266C21.2949 11.3083 30.9186 23.978 42.1905 34.6283C43.25 35.638 44.3095 36.5992 45.369 37.5603C47.1937 39.1914 49.0968 40.7059 51 42.1719C50.1956 43.0068 49.3911 43.8515 48.5867 44.6476C46.7228 46.5311 44.7706 48.5019 42.8281 50.4339C41.9845 49.6378 41.131 48.8417 40.3266 48.0456C38.5509 46.3272 36.7655 44.6088 34.9408 42.8418C23.6297 31.939 11.8477 19.8615 4.0977 6.69667C2.14548 3.38604 5.83409 -0.808081 9.17935 1.83266Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </form>
          </td>
        </tr>
        <tr class="result">
          <td>Total :</td>
          <td>{{ getTotal }}€</td>
        </tr>
        </tbody>
      </table>

      <!--TODO logo cb, petits textes ...-->
      <div class="icons">
        <span>100% sécurisé</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="118.511" height="18" viewBox="0 0 118.511 18">
          <defs>
            <radialGradient id="radial-gradient" cx="0.175" cy="0.175" r="0.935"
                            gradientTransform="matrix(0.998, 0, 0, -1, 0, 0.349)"
                            gradientUnits="objectBoundingBox">
              <stop offset="0" stop-color="#9dd5f6"/>
              <stop offset="0.071" stop-color="#98d3f5"/>
              <stop offset="0.157" stop-color="#89cef3"/>
              <stop offset="0.252" stop-color="#70c6ef"/>
              <stop offset="0.351" stop-color="#4ebbea"/>
              <stop offset="0.455" stop-color="#23ade3"/>
              <stop offset="0.5" stop-color="#0da6e0"/>
              <stop offset="1" stop-color="#2e77bc"/>
            </radialGradient>
          </defs>
          <g id="Groupe_7916" data-name="Groupe 7916" transform="translate(-600 -351)">
            <g id="Logo_Mastercard" data-name="Logo Mastercard" transform="translate(634 351)">
              <path id="Tracé_10699" data-name="Tracé 10699"
                    d="M24.2,94.521V93.33a.706.706,0,0,0-.745-.755.733.733,0,0,0-.666.338.7.7,0,0,0-.626-.338.626.626,0,0,0-.555.282v-.234H21.19v1.9h.416V93.477a.445.445,0,0,1,.464-.5c.274,0,.412.179.412.5v1.057H22.9V93.477a.447.447,0,0,1,.464-.5c.281,0,.416.179.416.5v1.057Zm6.159-1.9h-.678v-.576H29.26v.576h-.377V93h.385v.874c0,.441.17.7.658.7a.966.966,0,0,0,.515-.147l-.119-.353a.76.76,0,0,1-.365.107c-.2,0-.274-.127-.274-.318V93h.674Zm3.517-.048a.559.559,0,0,0-.5.278v-.23h-.408v1.9h.412V93.457c0-.314.135-.489.4-.489a.671.671,0,0,1,.258.048l.127-.4a.881.881,0,0,0-.293-.052Zm-5.317.2a1.416,1.416,0,0,0-.773-.2c-.48,0-.793.23-.793.608,0,.31.23.5.654.56l.2.028c.226.032.333.091.333.2,0,.147-.151.23-.432.23a1.008,1.008,0,0,1-.63-.2l-.2.322a1.366,1.366,0,0,0,.821.246c.547,0,.864-.258.864-.62s-.25-.508-.662-.568l-.2-.028c-.178-.024-.321-.06-.321-.187s.135-.222.361-.222a1.219,1.219,0,0,1,.595.163Zm11.044-.2a.559.559,0,0,0-.5.278v-.23H38.69v1.9H39.1V93.457c0-.314.135-.489.4-.489a.671.671,0,0,1,.258.048l.127-.4a.881.881,0,0,0-.293-.052Zm-5.313.993a.958.958,0,0,0,1.011.993.99.99,0,0,0,.682-.226L35.78,94a.832.832,0,0,1-.5.171.61.61,0,0,1,0-1.215.832.832,0,0,1,.5.171l.2-.334a.99.99,0,0,0-.682-.226.958.958,0,0,0-1.011.993Zm3.862,0v-.945h-.412v.23a.719.719,0,0,0-.595-.278.993.993,0,0,0,0,1.986.719.719,0,0,0,.595-.278v.23h.412Zm-1.534,0a.57.57,0,1,1,.155.43.573.573,0,0,1-.155-.43Zm-4.976-.993a.993.993,0,0,0,.028,1.986,1.15,1.15,0,0,0,.787-.258l-.2-.306a.9.9,0,0,1-.551.2.526.526,0,0,1-.567-.465h1.407v-.159a.9.9,0,0,0-.9-.993Zm0,.369a.47.47,0,0,1,.48.461h-.991a.488.488,0,0,1,.5-.461Zm10.33.628V91.86h-.4v.993a.719.719,0,0,0-.595-.278.993.993,0,0,0,0,1.986.719.719,0,0,0,.595-.278v.23h.4Zm.688.673a.191.191,0,0,1,.178.113.185.185,0,0,1,0,.147.19.19,0,0,1-.1.1.186.186,0,0,1-.075.016.2.2,0,0,1-.178-.115.187.187,0,0,1,0-.147.192.192,0,0,1,.184-.113Zm0,.336a.141.141,0,0,0,.057-.012.143.143,0,0,0,.046-.23.147.147,0,0,0-.046-.032.143.143,0,0,0-.057-.012.149.149,0,0,0-.057.012.144.144,0,0,0-.048.032.144.144,0,0,0,.111.242Zm.012-.236a.079.079,0,0,1,.052.016.05.05,0,0,1,.018.042.048.048,0,0,1-.014.036.069.069,0,0,1-.042.018l.057.066h-.046l-.054-.066h-.018v.066h-.038v-.175Zm-.044.034v.048h.044a.042.042,0,0,0,.024,0,41.856,41.856,0,0,1,0-.036.042.042,0,0,0-.024,0Zm-2.181-.806A.57.57,0,1,1,40.6,94,.573.573,0,0,1,40.443,93.572Zm-13.922,0v-.949h-.412v.23a.719.719,0,0,0-.595-.278.993.993,0,0,0,0,1.986.719.719,0,0,0,.595-.278v.23h.412Zm-1.534,0a.563.563,0,1,1,.152.431.573.573,0,0,1-.152-.431Z"
                    transform="translate(-19.992 -76.62)" fill="#231f20"/>
              <rect id="Rectangle_1698" data-name="Rectangle 1698" width="6.256" height="11.242"
                    transform="translate(8.42 1.529)" fill="#ff5f00"/>
              <path id="_Path_" data-name="&lt;Path&gt;"
                    d="M23.992,22.3a7.137,7.137,0,0,1,2.731-5.622,7.149,7.149,0,1,0,0,11.242,7.137,7.137,0,0,1-2.731-5.62Z"
                    transform="translate(-15.155 -15.154)" fill="#eb001b"/>
              <path id="Tracé_10700" data-name="Tracé 10700"
                    d="M84.968,22.3A7.149,7.149,0,0,1,73.4,27.922a7.149,7.149,0,0,0,0-11.242A7.149,7.149,0,0,1,84.968,22.3Z"
                    transform="translate(-61.872 -15.151)" fill="#f79e1b"/>
              <path id="Tracé_10701" data-name="Tracé 10701"
                    d="M127.633,72.338v-.23h.093V72.06h-.236v.048h.1v.23Zm.459,0V72.06h-.072l-.083.2-.083-.2h-.064v.278h.052V72.13l.077.181h.054l.077-.181v.21Z"
                    transform="translate(-105.22 -60.755)" fill="#f79e1b"/>
            </g>
            <g id="Logo_Visa" transform="translate(666 356)">
              <path id="polygon9" d="M435.714,119.254h-2.207l1.381-8.527H437.1Z"
                    transform="translate(-423.921 -110.572)" fill="#00579f"/>
              <path id="path11"
                    d="M571.8,105.411a5.446,5.446,0,0,0-1.98-.363c-2.18,0-3.715,1.161-3.724,2.821-.018,1.225,1.1,1.905,1.935,2.313.854.417,1.144.69,1.144,1.062-.009.571-.69.835-1.326.835a4.4,4.4,0,0,1-2.071-.454l-.291-.136-.309,1.914a6.726,6.726,0,0,0,2.462.454c2.316,0,3.824-1.143,3.842-2.912.009-.971-.581-1.715-1.853-2.322-.772-.39-1.245-.653-1.245-1.052.009-.363.4-.735,1.271-.735a3.755,3.755,0,0,1,1.644.327l.2.091.3-1.841Z"
                    transform="translate(-552.012 -105.048)" fill="#00579f"/>
              <path id="path13"
                    d="M793.937,116.233c.182-.49.881-2.386.881-2.386-.009.018.181-.5.29-.816l.154.735s.418,2.041.509,2.467Zm2.725-5.506h-1.707a1.089,1.089,0,0,0-1.154.707l-3.279,7.819h2.316l.463-1.279h2.834c.063.3.263,1.279.263,1.279h2.044l-1.781-8.527Z"
                    transform="translate(-771.23 -110.572)" fill="#00579f"/>
              <path id="path15"
                    d="M171.286,110.727l-2.162,5.815-.236-1.179a6.529,6.529,0,0,0-3.052-3.574l1.98,7.457h2.334l3.47-8.518Z"
                    transform="translate(-163.528 -110.572)" fill="#00579f"/>
              <path id="path17"
                    d="M84.754,110.727H81.2l-.036.172a7.386,7.386,0,0,1,5.359,4.469l-.772-3.924a.913.913,0,0,0-1-.718Z"
                    transform="translate(-81.166 -110.572)" fill="#faa61a"/>
              <g id="Ellipse_682" data-name="Ellipse 682" transform="translate(27.358 7.662)" fill="#fff"
                 stroke="#00579f" stroke-width="1">
                <ellipse cx="0.496" cy="0.496" rx="0.496" ry="0.496" stroke="none"/>
                <ellipse cx="0.496" cy="0.496" rx="0.004" ry="0.004" fill="none"/>
              </g>
              <path id="Tracé_10702" data-name="Tracé 10702"
                    d="M-2.825-6.714v-.444h.2a.262.262,0,0,1,.09.012.1.1,0,0,1,.049.042.126.126,0,0,1,.018.067.112.112,0,0,1-.031.08.155.155,0,0,1-.095.041.152.152,0,0,1,.035.022.305.305,0,0,1,.049.059l.077.121h-.074l-.059-.092q-.026-.04-.042-.061a.133.133,0,0,0-.03-.03.088.088,0,0,0-.027-.012l-.033,0h-.068v.2Zm.059-.248h.126a.189.189,0,0,0,.063-.008A.067.067,0,0,0-2.542-7a.072.072,0,0,0,.012-.04.066.066,0,0,0-.023-.052.107.107,0,0,0-.072-.02h-.141Z"
                    transform="translate(30.492 15.068)" fill="#00579f"/>
            </g>
            <g id="Logo_CB" transform="translate(600 355)">
              <path id="Tracé_1838" data-name="Tracé 1838"
                    d="M138.643,2.595A2.6,2.6,0,0,0,136.048,0H126.6V5.2h9.448A2.615,2.615,0,0,0,138.643,2.595Z"
                    transform="translate(-112.671)" fill="#01acba"/>
              <path id="Tracé_1839" data-name="Tracé 1839"
                    d="M138.643,52.295a2.6,2.6,0,0,0-2.595-2.595H126.6v5.2h9.448A2.615,2.615,0,0,0,138.643,52.295Z"
                    transform="translate(-112.671 -44.249)" fill="#01acba"/>
              <path id="Tracé_1840" data-name="Tracé 1840"
                    d="M6.92,5.836V5.526h6.942V5.1A4.714,4.714,0,0,0,9.138.4H4.724a4.725,4.725,0,0,0-3.34,1.368A4.672,4.672,0,0,0,0,5.086V6.343a4.714,4.714,0,0,0,4.724,4.7H9.138a4.714,4.714,0,0,0,4.724-4.7V5.836Z"
                    transform="translate(0 -0.356)" fill="#01acba"/>
            </g>
            <g id="Groupe_7827" data-name="Groupe 7827" transform="translate(702 352)">
              <path id="Tracé_5606" data-name="Tracé 5606"
                    d="M16.412,0H0V16.476H16.412V11.039a.629.629,0,0,0,.1-.361.568.568,0,0,0-.1-.361"
                    fill="url(#radial-gradient)"/>
              <path id="Tracé_5607" data-name="Tracé 5607"
                    d="M1.479,98.479l-.314-.769-.314.769m7.586-.3a.408.408,0,0,1-.227.041H7.65v-.431h.571a.52.52,0,0,1,.221.035.18.18,0,0,1,.1.169A.241.241,0,0,1,8.436,98.176Zm4,.3-.32-.769-.32.769Zm-7.452.838H4.512V97.8l-.67,1.514H3.435L2.765,97.8v1.514H1.822l-.175-.431H.687l-.18.431h-.5l.827-1.933H1.52l.78,1.828V97.384h.751l.605,1.31.553-1.31h.769l.006,1.933Zm1.881,0H5.327V97.384H6.87v.4H5.787v.349H6.841v.4H5.787v.384H6.864ZM9.042,97.9a.535.535,0,0,1-.326.512.545.545,0,0,1,.227.163.557.557,0,0,1,.076.355v.378H8.553v-.245a.567.567,0,0,0-.076-.378c-.07-.07-.169-.082-.338-.082H7.644v.7h-.46V97.378h1.06a1.086,1.086,0,0,1,.559.093A.457.457,0,0,1,9.042,97.9Zm.739,1.415H9.309V97.384h.472Zm5.461,0H14.59l-.873-1.45v1.45h-.937l-.18-.431h-.961l-.175.431h-.541a.818.818,0,0,1-.914-.955,1.04,1.04,0,0,1,.25-.757.952.952,0,0,1,.7-.227h.448v.413h-.437a.434.434,0,0,0-.355.116.619.619,0,0,0-.134.437.661.661,0,0,0,.128.454.441.441,0,0,0,.32.1h.21l.652-1.52h.693l.78,1.828V97.378h.7l.809,1.345V97.378h.472v1.939ZM0,99.7H.786l.18-.431h.4l.175.431H3.086V99.37l.14.332h.8l.14-.332V99.7H8.023V99H8.1c.052,0,.07.006.07.093V99.7h1.991v-.163a1.58,1.58,0,0,0,.739.163h.838l.18-.431h.4l.175.431h1.619v-.408l.245.408h1.292V97H14.363v.32l-.18-.32H12.867v.32L12.7,97H10.928a1.578,1.578,0,0,0-.769.157V97H8.931v.157A.781.781,0,0,0,8.407,97H3.936l-.3.7L3.33,97H1.915v.32L1.764,97H.559L0,98.281V99.7Z"
                    transform="translate(0 -91.353)" fill="#fff"/>
              <path id="Tracé_5608" data-name="Tracé 5608"
                    d="M69.246,154.8h-.838a.344.344,0,0,0-.186.035.152.152,0,0,0-.07.14.147.147,0,0,0,.1.146.5.5,0,0,0,.18.023l.25.006a.74.74,0,0,1,.524.157.292.292,0,0,1,.041.047m0,.722a.722.722,0,0,1-.629.245h-.891V155.9h.885a.266.266,0,0,0,.186-.047.162.162,0,0,0,.052-.128.158.158,0,0,0-.058-.128.239.239,0,0,0-.163-.041c-.431-.017-.972.012-.972-.6a.579.579,0,0,1,.664-.576h.92V154h-.856a.985.985,0,0,0-.576.157V154H66.545a.9.9,0,0,0-.553.157V154H63.738v.157a1.218,1.218,0,0,0-.623-.157h-1.49v.157a1.04,1.04,0,0,0-.652-.157H59.308l-.378.413L58.574,154H56.1v2.7h2.439l.39-.419.373.419h1.5v-.635h.146a1.545,1.545,0,0,0,.64-.093v.728h1.24v-.7h.058c.076,0,.082.006.082.081v.623h3.778a1.086,1.086,0,0,0,.629-.175v.175h1.193a1.627,1.627,0,0,0,.675-.122v-.5Zm-1.84-.774a.545.545,0,0,1,.14.408c0,.413-.262.611-.722.611h-.9V155.9h.9a.266.266,0,0,0,.186-.047.185.185,0,0,0,.052-.128A.158.158,0,0,0,67,155.6a.239.239,0,0,0-.163-.041c-.431-.017-.972.012-.972-.6a.574.574,0,0,1,.658-.576h.926v.413h-.844a.344.344,0,0,0-.186.035.142.142,0,0,0-.07.14.147.147,0,0,0,.1.146.5.5,0,0,0,.18.023l.25.006A.741.741,0,0,1,67.406,155.3Zm-4.163-.116a.467.467,0,0,1-.227.041h-.559v-.431h.571a.444.444,0,0,1,.221.035.185.185,0,0,1,.093.175A.2.2,0,0,1,63.244,155.182Zm.279.239a.509.509,0,0,1,.227.163.557.557,0,0,1,.076.355v.384H63.36v-.239a.567.567,0,0,0-.076-.378.445.445,0,0,0-.338-.087h-.495v.7h-.466V154.39h1.065a1.126,1.126,0,0,1,.553.093.455.455,0,0,1,.239.431A.52.52,0,0,1,63.523,155.421Zm.582-1.03h1.537v.4H64.559v.349h1.054v.4H64.559v.384h1.083v.4H64.105ZM61,155.281H60.4v-.489H61c.169,0,.279.07.279.239S61.171,155.281,61,155.281Zm-1.06.862-.71-.786.71-.763Zm-1.828-.227H56.973v-.384h1.013v-.4H56.973v-.349h1.159l.507.565Zm3.668-.891c0,.536-.4.646-.8.646H60.4v.646h-.9l-.571-.64-.588.64H56.513v-1.933h1.857l.571.635.588-.635H61C61.363,154.39,61.776,154.489,61.776,155.025Z"
                    transform="translate(-52.834 -145.034)" fill="#fff"/>
            </g>
          </g>
        </svg>
      </div>
    </div>
  </aside>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {getAPI} from "@/services/axios-api";

export default {
  name: "CartResume",
  props: {
    step: {
      type: [String, Number],
    },
  },
  data() {
    return {
      form: {
        discount: '',
        cart: null,
      },
      display: false,
    }
  },
  computed: {
    ...mapGetters('cart', ['getMyCartItems', 'getMyCart', 'getShippingCost', 'isSplit', 'getTotalPrice', 'getTotal', 'getAmountDiscount']),
    ...mapGetters('error', ['getErrorMessage']),
    ...mapState('auth', ['userId', 'isAuthenticated']),
  },
  mounted() {
    const headerHeight = document.querySelector('header').offsetHeight
    const fixedCartResume = document.querySelector('.cart-resume-container')

    fixedCartResume.style.top = `${headerHeight + 5}px`
  },
  methods: {
    getDiscount: async function () {
      this.form.cart = this.getMyCart
      await getAPI
          .post("ecommerce/discount/", this.form)
          .then(r => {
            this.display = false;
            this.$store.dispatch('cart/setDiscount', r.data)
          })
          .catch(e => {
            this.display = true;
            this.$store.dispatch('error/setError', e.response.data)
          })
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/scss/variables' as *;
.error {
  // @include color('background-color', $Red, .3);
  background-color: rgb(238 206 206);
  border-radius: 5px;
  box-shadow: 0 2px 10px -2px #00000033;
  width: 100%;

  p, li {
    font-size: 14px;
    font-weight: 600;
    color: $Red;
    padding: 5px 10px;
    text-align: center;

  }
}

.cart-resume-container {
  @include position(0, $right: 0, $position: sticky);
  width: 100%;

  @media screen and (min-width: 576px) {
    width: fit-content;
  }

  @media screen and (min-width: 992px) {
    flex: 0 0 calc(33% - 10px);
    max-width: calc(33% - 10px);
  }

  .wrapper {
    box-shadow: 0 6px 10px -3px rgba(0, 0, 0, 30%);
    border-radius: 10px;

    h2 {
      color: #000000;
      text-transform: uppercase;
      font-weight: 600;
      margin: 20px 20px 0 20px;
      border-bottom: solid 1px $Brown;
      font-size: 16px;
    }

    .main-cart {
      border-spacing: 10px;
      padding: 10px;
      width: 100%;

      .main-cart__body {
        display: table-row-group;
      }

      .main-cart__body:not(:last-of-type):after {
        bottom: 0;
        height: .5px;
      }

      .city {
        font-size: 13px;
        translate: 0;
      }

      .item {
        &__price, h3 {
          font-size: 14px;
          font-weight: 600;
        }

        &__price {
          text-align: right;
        }

        &::after {
          display: none;
        }

        &__meta__img {
          max-height: 30px;
          max-width: 30px;
        }
      }

      .details {
        font-size: 13px;

        &.promotion {
          color: $Green;
        }

        td {
          text-align: right;
        }
      }

      .total-price {
        .promo-code {
          text-align: right;
          font-size: 12px;

          form {
            width: 100%;

            .form__row {
              @include flex(flex-end, center, row);
              width: 100%;
              text-align: center;

              @media screen and (min-width: 568px) {
                flex-direction: row;
              }

              input {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                height: 35px;
                border-right: none;
              }

              button {
                padding: 5px;
                height: 35px;
                font-size: 16px;
                width: 100%;
                aspect-ratio: 1;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;

                @media screen and (min-width: 568px) {
                  width: auto;
                }

                svg {
                  @include fixed-size(20px)
                }
              }
            }
          }

          a {
            color: $Blue;
            transition: .2s;

            &:hover {
              opacity: .8;
            }
          }
        }

        .result {
          font-size: 18px;
          font-weight: 700;
          text-align: right;
        }
      }

    }

    .icons {
      @include flex(flex-end, center, $gap: 7.5px);
      padding: 10px 20px;
      border-top: solid 1px #ccc;
      font-size: 10px;
      font-weight: 700;

      img {
        max-width: 20px;
        max-height: 15px;
        object-fit: cover;
      }
    }
  }

}

section {
  @include flex(flex-start, flex-start, column);
  width: 100%;
  margin-bottom: 20px;

  .main-title {
    @include flex(flex-start, center, $gap: 8px);
    position: relative;

    h2 {
      color: $Black;
      font-size: 20px;
      font-weight: 600;
      position: relative;
      letter-spacing: 1px;
    }

    svg {
      @include fixed-size(20px);
      @media screen and (min-width: 768px) {
        @include position(50%, -25px);
        translate: 0 -50%;
      }
    }

  }

  .sub-title {
    margin-bottom: 25px;

    h3 {
      letter-spacing: 1px;
      font-weight: 400;
      font-size: 15px;
    }
  }

  .date-picker {
    margin-top: 20px;
    @include flex(space-between, flex-start, $gap: 25px);
    width: 100%;

    @media screen and (max-width: 767.99px) {
      flex-direction: column;
    }
    @media screen and (max-width: 575.99px) {
      gap: 10px;
    }
  }

}
</style>